import { render } from "./InvoiceItemTable.vue?vue&type=template&id=47b104a9&scoped=true&ts=true&lang=pug"
import script from "./InvoiceItemTable.vue?vue&type=script&lang=ts"
export * from "./InvoiceItemTable.vue?vue&type=script&lang=ts"

import "./InvoiceItemTable.vue?vue&type=style&index=0&id=47b104a9&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b104a9"]])

export default __exports__